import { useCallback, useEffect, useState } from "react";
import type { KnowledgeFilter } from "@/lib/types";

const KEY_DEMO = "datacom.demoMode";
const KEY_FILTER = "datacom.knowledgeFilter";
const KEY_ENTERED = "datacom.entered";

/**
 * La versione, da package.json (vedi vite.config.ts).
 *
 * Era scritta a mano qui e diceva "0.1.0-demo": la parola "demo" sarebbe
 * finita nelle impostazioni di un app pubblicata sugli store. Ora c e un posto
 * solo da aggiornare, ed e quello che conta anche per il pacchetto.
 */
declare const __VERSIONE_APP__: string;
export const APP_VERSION = typeof __VERSIONE_APP__ === "string" ? __VERSIONE_APP__ : "sconosciuta";

function readBool(key: string, fallback: boolean) {
  if (typeof window === "undefined") return fallback;
  const v = localStorage.getItem(key);
  if (v === null) return fallback;
  return v === "true";
}

/**
 * LA MODALITA' DEMO NON SI ACCENDE PIU' (06/10/2026).
 *
 * L'interruttore e' sparito dalle impostazioni da mesi, ma il browser di chi
 * l'aveva acceso se lo ricordava: la chat rispondeva col simulatore - frasi
 * preconfezionate che sembrano vere - finche' quella persona non riapriva le
 * Impostazioni (che lo spegnevano). Ora vale sempre «spenta», e il ricordo si
 * cancella al primo avvio. Il codice del simulatore si toglie col punto D2
 * dell'audit; intanto non puo' piu' rispondere a nessuno.
 */
try {
  if (typeof window !== "undefined") localStorage.removeItem(KEY_DEMO);
} catch {
  // storage non disponibile: non c'era niente da cancellare
}

export function useDemoMode() {
  const demoMode = false;
  const setDemoMode = useCallback((_v: boolean) => {
    // Non si accende piu': vedi sopra.
  }, []);
  return { demoMode, setDemoMode };
}

export function useKnowledgeFilter() {
  const [filter, setFilterState] = useState<KnowledgeFilter>(() => {
    if (typeof window === "undefined") return "all";
    const v = localStorage.getItem(KEY_FILTER);
    if (v === "ajax" || v === "daitem" || v === "all") return v;
    return "all";
  });

  const setFilter = useCallback((v: KnowledgeFilter) => {
    setFilterState(v);
    try { localStorage.setItem(KEY_FILTER, v); } catch { /* storage non disponibile: la scelta vale per questa sessione */ }
  }, []);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY_FILTER && (e.newValue === "ajax" || e.newValue === "daitem" || e.newValue === "all")) {
        setFilterState(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return { filter, setFilter };
}

export function useOnboarded() {
  const [entered, setEntered] = useState<boolean>(() => readBool(KEY_ENTERED, false));
  const markEntered = useCallback(() => {
    setEntered(true);
    try { localStorage.setItem(KEY_ENTERED, "true"); } catch { /* storage non disponibile: la scelta vale per questa sessione */ }
  }, []);
  const resetEntered = useCallback(() => {
    setEntered(false);
    try { localStorage.removeItem(KEY_ENTERED); } catch { /* storage non disponibile: la scelta vale per questa sessione */ }
  }, []);
  return { entered, markEntered, resetEntered };
}